import { ICampaignType } from '~/modules/campaign/types';

/** Why a template can't be picked, by the kind of experiment already holding it. */
export const USED_IN_OTHER_EXPERIMENT_TOOLTIP: Partial<Record<ICampaignType, string>> = {
  [ICampaignType.PRICE]: "This template is in another price experiment and can't be selected.",
  [ICampaignType.URL]: "This template is in another URL experiment and can't be selected.",
};

/** Read when the holding experiment names no kind of its own — a plain template test. */
export const USED_IN_OTHER_EXPERIMENT_TOOLTIP_FALLBACK =
  "This template is in another experiment and can't be selected";

/** Same, for a template several experiments hold at once. */
export const USED_IN_MULTIPLE_EXPERIMENTS_TOOLTIP: Partial<Record<ICampaignType, string>> = {
  [ICampaignType.PRICE]:
    "This template is already in other price experiments and can't be selected.",
  [ICampaignType.URL]: "This template is already in other URL experiments and can't be selected.",
};

/** Read when experiments of more than one kind hold the template, which naming either would misread. */
export const USED_IN_MULTIPLE_EXPERIMENTS_TOOLTIP_FALLBACK =
  "This template is already in other experiments and can't be selected.";
